import { ColumnDef } from '@tanstack/react-table';
import { format, parseISO } from 'date-fns';
import { ActingQueryData } from '@area-restrita/api-client/model/actingQueryData';

export const columns: ColumnDef<ActingQueryData>[] = [
  {
    header: 'Iniciado Por',
    accessorFn: (row) => row.startedBy.name ?? 'N/A',
  },
  {
    header: 'Status',
    accessorFn: (row) => row.status.toUpperCase(),
  },
  {
    header: 'Iniciado Em',
    accessorFn: (row) => format(parseISO(row.startedAt), 'dd/MM/yyyy HH:mm'),
  },
  {
    header: 'Finalizado Em',
    accessorFn: (row) =>
      row.finishedAt
        ? format(parseISO(row.finishedAt), 'dd/MM/yyyy HH:mm')
        : '-',
  },
  {
    header: 'Checklist',
    accessorFn: (row) => row.usedChecklist?.name ?? 'N/A',
  },
];
